// Dock section wrapping `ActivityPanelAchievements` with the `mt-3` spacing
// that the expanded panel previously applied inline. Keeping the spacing
// inside the section means future reorderings (insert/move via
// `sectionRegistry.tsx`) don't have to repeat the spacing decision.
//
// RP-7 of docs/planning/firefly_role_context_presentation.md (closes
// §7 L6): the section now reads `currentBucket` off the render context
// and forwards it to `ActivityPanelAchievements`, which uses it to
// filter the gallery down to bucket-relevant achievement categories
// (the per-bucket subset map lives in `src/lib/achievementBucketFilter.ts`).
// The section itself stays bucket-agnostic — its `roleGate` is still
// `"any-dock-audience"` and `bucketRelevance` is still omitted. What
// changes is the *items* inside the gallery, not whether the section
// renders. When `currentBucket` is null (early bootstrap) the filter
// falls back to "show everything," preserving today's behavior.

import type { DockSectionRenderContext } from "../sectionTypes";
import { ActivityPanelAchievements } from "../ActivityPanelAchievements";

export function AchievementsSection({
  currentBucket,
}: Pick<DockSectionRenderContext, "currentBucket">) {
  return (
    <div className="mt-3">
      <ActivityPanelAchievements bucketId={currentBucket} />
    </div>
  );
}
